// extracted by mini-css-extract-plugin
export var printerCard = "_ac-1";
export var printerCardConfigured = "_ac-2";
export var printerCardError = "_ac-3";
export var printerCardsContainer = "_ac-0";
export var printerIcon = "_ac-8";
export var printerIconConfigured = "_ac-5";
export var printerIconContainer = "_ac-4";
export var printerIconError = "_ac-6";
export var printerIconUnconfigured = "_ac-7";